const bgImage = 'https://i0.wp.com/www.quickpconline.com/pc/wp-content/uploads/2020/04/cover-csq-sely.jpg?resize=1024%2C683'
const website = 'https://www.tiba.rsquareth.com/'

window.profileConfig = {
  companyName: 'สมาคมนายหน้าประกันภัยไทย',
  destinationLink: website,
  backgroundImage: bgImage,
  themeColor: 'warning',
  comId: 500,
  style: {
    // Ex. color: 'red'
  }
}